import type { AppointmentScrollQuery } from "@/openapi/generated/models";

/** Shared with MemberDashboardPage - keep query objects identical for cache hits. */
export const MEMBER_DASHBOARD_APPOINTMENT_SCROLL_QUERY: AppointmentScrollQuery =
  {
    locationId: null,
    teacherId: null,
    includeOnlyOnline: true,
    date: null,
    searchQuery: null,
  };
